import { state, update } from 'bey-fix'
import { datadogLogs } from '@datadog/browser-logs'

import { DEFAULT_LOCALE } from '../helpers/locale'

const language = state({
  language: DEFAULT_LOCALE,
})

const persistLanguage = () => {
  try {
    localStorage.setItem('language', language.get().language)
  } catch (error) {
    datadogLogs.logger.warn(`language.persistLanguage: ${error.message}`)
  }
}

export const setLanguage = (newLanguage = DEFAULT_LOCALE) => {
  update(language, (state) => {
    state.language = newLanguage
  })
  persistLanguage()
}

export default language
